/*
  This file defines all the helper functions that are used throughout the application
*/

export default {
  methods: {
    safeParseJson:function(jsonString){
      try {
        return JSON.parse(jsonString);
      } catch(e){
        return false;
      }
    },
    getCompanyTimezone:function(){
      return $('meta[name="timezone"]').attr('content');
    },
    datetimeToCompanyTime:function(dateTime, inFormat, outFormat){
      inFormat = inFormat == 'default' ? 'YYYY-MM-DD HH:mm:ss' : inFormat;
      //returns current time in company timezone
      var companytz = this.getCompanyTimezone();
      var outFormat = outFormat ? outFormat : 'YYYY-MM-DD HH:mm:ss';
      return moment.utc(dateTime, inFormat).tz(companytz).format(outFormat);
    },
    utcToLocal:function(dateTime, inFormat, outFormat){
      inFormat = inFormat == 'default' ? 'YYYY-MM-DD HH:mm:ss' : inFormat;
      //returns current time in company timezone
      var outFormat = outFormat ? outFormat : 'YYYY-MM-DD HH:mm:ss';
      return moment.utc(dateTime, inFormat).tz(moment.tz.guess()).format(outFormat);
    },
    get:function(property, o, defaultValue){
      //safely grabs property value from an object
      //we send back the default value if null is found
      defaultValue = defaultValue == undefined ? '': defaultValue;
      return property.reduce(function(xs, x){
        return xs && (x in xs) && xs[x] != null ? xs[x] : defaultValue;
      }, o);
    },
    ucFirst: function(s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    refreshPage:function(){
      location.reload();
    },
    showSnackbarError:function(message) {
      toastr.error(message);
    },
    showSnackbarSuccess:function(message) {
      toastr.success(message);
    },
    getUrlParams:function() {
      var vars = {};
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
          vars[key] = value;
      });
      return vars;
    },
    getUrlParam:function(parameter, defaultvalue){
      var urlparameter = defaultvalue || false;
      if(window.location.href.indexOf(parameter) > -1){
          urlparameter = this.getUrlParams()[parameter];
          }
      return urlparameter;
    },
    reduceDates:function(startString, endString){
      //set the dates to variable
      var start = moment(startString, 'YYYY-MM-DD HH:mm:ss');
      var end = moment(endString, 'YYYY-MM-DD HH:mm:ss');

      //generate a string from the dates
      var dateRange = start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY');

      //if dates have same year, remove year from start date
      if(start.year() == end.year()){
        dateRange = start.format('MMM D') + ' - ' + end.format('MMM D, YYYY');
      }

      //if dates have same month and year, remove month from end date
      if(start.month() == end.month() && start.year() == end.year()){
        dateRange = start.format('MMM D') + ' - ' + end.format('D, YYYY');
      }

      //if dates have same day, month, and year, start date
      if(start.date() == end.date() && start.month() == end.month() && start.year() == end.year()){
        dateRange = end.format('MMM D, YYYY');
      }

      return dateRange;
    },
    reduceTimes:function(startString, endString){
      //set the dates to variable
      var start = moment(startString, 'YYYY-MM-DD HH:mm:ss');
      var end = moment(endString, 'YYYY-MM-DD HH:mm:ss');

      //generate a string from the dates
      var dateRange = start.format('h:mm A') + ' - ' + end.format('h:mm A');

      //if times have same hour, remove hour from start time
      if(start.hour() == end.hour()){
        dateRange = start.format('h:mm') + ' - ' + end.format('h:mm A');
      }

      //if times have same minute and hour, remove minute from end time
      if(start.minute() == end.minute() && start.hour() == end.hour()){
        dateRange = start.format('h:mm') + ' - ' + end.format('h A');
      }

      //if times have same minute, hour, and day, start time
      if(start.minute() == end.minute() && start.hour() == end.hour() && start.date() == end.date()){
        dateRange = end.format('h:mm A');
      }

      return dateRange;
    },
    formatDate: function(date, format){
      //check if date is empty
      if(date == null || date == ''){ return }
      //check if date is string
      if(typeof date === 'string'){
        date = moment(date, 'YYYY-MM-DD HH:mm:ss');
      }
      return date.format(format);
    },
    roundToTwo: function(num) {
      //convert num to number
      var num = +(num);

      return +(Math.round(num + "e+2")  + "e-2");
    },
    convertNumberToCurrency:function(number){
      //check if number is empty
      if(number == null || number === ''){ return }
      //check if number is string
      if(typeof number === 'string'){
        number = parseFloat(number);
      }
      return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    },
    numberWithCommas:function(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    uuidv4: function() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    getTripStatusLabel: function(status, withoutIcon){
      //convert status to string
      status = ''+status;
      switch (status) {
        case '0':
          var label = $('<div class="aro simple label small error">DENIED</div>');
          if(!withoutIcon){
            label.prepend('<div class="aro small error dot m-r-5"></div>');
          }
          return label.get(0).outerHTML;
          break;
        case '1':
          var label = $('<div class="aro simple label small default">DRAFT</div>');
          if(!withoutIcon){
            label.prepend('<i class="uil uil-unlock m-r-5" style="font-size:18px;"></i>');
          }
          return label.get(0).outerHTML;
          break;
        case '2':
          var label = $('<div class="aro simple label small warning">PENDING</div>');
          if(!withoutIcon){
            label.prepend('<i class="uil uil-hourglass m-r-5" style="font-size:18px;"></i>');
          }
          return label.get(0).outerHTML;
          break;
        case '3':
          var label = $('<div class="aro simple label small success">APPROVED</div>');
          if(!withoutIcon){
            label.prepend('<div class="aro small success dot m-r-5"><i class="uil uil-check"></i></div>');
          }
          return label.get(0).outerHTML;
        case '4':
          var label = $('<div class="aro simple label small success">BOOKED</div>');
          if(!withoutIcon){
            label.prepend('<i class="uil uil-ticket m-r-5" style="font-size:18px;"></i>');
          }
          return label.get(0).outerHTML;
          break;
        case '5':
          var label = $('<div class="aro simple label small success-dark">ALLOCATION</div>');
          if(!withoutIcon){
            label.prepend('<i class="uil uil-dollar-sign-alt" style="font-size:18px;"></i>');
          }
          return label.get(0).outerHTML;
          break;
        case '6':
          var label = $('<div class="aro simple label small primary">REIMBURSEMENT</div>');
          if(!withoutIcon){
            label.prepend('<div class="aro small primary dot m-r-5"></div>');
          }
          return label.get(0).outerHTML;
          break;
        case '10':
          var label = $('<div class="aro simple label small success">COMPLETE</div>');
          if(!withoutIcon){
            label.prepend('<i class="uil uil-check-circle" style="font-size:18px;"></i>');
          }
          return label.get(0).outerHTML;
          break;
        default:
          var label = $('<div class="aro simple label small default">UNKNOWN STATUS</div>');
          if(!withoutIcon){
            label.prepend('<i class="uil uil-exclamation-triangle m-r-5" style="font-size:18px;"></i>');
          }
          return label.get(0).outerHTML;
      }
    },
    chartJsPlugins:function(name){
      var plugins = {
        donuttext : {
          id: 'donuttext',
          beforeDraw: function(chart) {
            if (get(['config','options','plugins','donuttext','center'], chart)) {
              // Get ctx from string
              var ctx = chart.ctx;

              // Get options from the center object in options
              var centerConfig = chart.config.options.plugins.donuttext.center;
              var fontStyle = centerConfig.fontStyle || 'Arial';
              var txt = centerConfig.text;
              var color = centerConfig.color || '#000';
              var maxFontSize = centerConfig.maxFontSize || 75;
              var sidePadding = centerConfig.sidePadding || 20;
              var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
              // Start with a base font of 30px
              ctx.font = "30px " + fontStyle;

              // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
              var stringWidth = ctx.measureText(txt).width;
              var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

              // Find out how much the font can grow in width.
              var widthRatio = elementWidth / stringWidth;
              var newFontSize = Math.floor(30 * widthRatio);
              var elementHeight = (chart.innerRadius * 2);

              // Pick a new font size so it will not be larger than the height of label.
              var fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
              var minFontSize = centerConfig.minFontSize;
              var lineHeight = centerConfig.lineHeight || 25;
              var wrapText = false;

              if (minFontSize === undefined) {
                minFontSize = 20;
              }

              if (minFontSize && fontSizeToUse < minFontSize) {
                fontSizeToUse = minFontSize;
                wrapText = true;
              }

              // Set font settings to draw it correctly.
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
              var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
              ctx.font = fontSizeToUse + "px " + fontStyle;
              ctx.fillStyle = color;

              if (!wrapText) {
                ctx.fillText(txt, centerX, centerY);
                return;
              }

              var words = txt.split(' ');
              var line = '';
              var lines = [];

              // Break words up into multiple lines if necessary
              for (var n = 0; n < words.length; n++) {
                var testLine = line + words[n] + ' ';
                var metrics = ctx.measureText(testLine);
                var testWidth = metrics.width;
                if (testWidth > elementWidth && n > 0) {
                  lines.push(line);
                  line = words[n] + ' ';
                } else {
                  line = testLine;
                }
              }

              // Move the center up depending on line height and number of lines
              centerY -= (lines.length / 2) * lineHeight;

              for (var n = 0; n < lines.length; n++) {
                ctx.fillText(lines[n], centerX, centerY);
                centerY += lineHeight;
              }
              //Draw text in center
              ctx.fillText(line, centerX, centerY);
            }
          }
        },
        htmlLegend: {
          id: 'htmlLegend',
          afterUpdate(chart, args, options) {
            const getOrCreateLegendList = (chart, elem) => {
              const legendContainer = elem;
              let listContainer = legendContainer.querySelector('ul');

              if (!listContainer) {
                listContainer = document.createElement('ul');
                listContainer.style.display = 'flex';
                listContainer.style.flexDirection = 'column';
                listContainer.style.margin = 0;
                listContainer.style.padding = 0;

                legendContainer.appendChild(listContainer);
              }

              return listContainer;
            };

            const ul = getOrCreateLegendList(chart, options.containerID);

            // Remove old legend items
            while (ul.firstChild) {
              ul.firstChild.remove();
            }

            // Reuse the built-in legendItems generator
            const items = chart.options.plugins.legend.labels.generateLabels(chart);

            items.forEach(item => {
              const li = document.createElement('li');
              li.style.alignItems = 'center';
              li.style.cursor = 'pointer';
              li.style.display = 'flex';
              li.style.flexDirection = 'row';
              li.style.marginLeft = '0px';
              li.style.marginTop = '4px';

              li.onclick = () => {
                const {type} = chart.config;
                if (type === 'pie' || type === 'doughnut') {
                  // Pie and doughnut charts only have a single dataset and visibility is per item
                  chart.toggleDataVisibility(item.index);
                } else {
                  chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                }
                chart.update();
              };

              // Color box
              const boxSpan = document.createElement('span');
              boxSpan.style.background = item.fillStyle;
              boxSpan.style.borderColor = item.strokeStyle;
              boxSpan.style.borderWidth = item.lineWidth + 'px';
              boxSpan.style.display = 'inline-block';
              boxSpan.style.height = '14px';
              boxSpan.style.marginRight = '10px';
              boxSpan.style.width = '14px';
              boxSpan.style.borderRadius = '4px';
              boxSpan.style.flexShrink = '0';
              boxSpan.style.flexBasis = '14px';

              // Text
              const textContainer = document.createElement('p');
              textContainer.style.color = item.fontColor;
              textContainer.style.fontSize = '12px';
              textContainer.style.margin = 0;
              textContainer.style.padding = 0;
              textContainer.style.textDecoration = item.hidden ? 'line-through' : '';

              const text = document.createTextNode(item.text);
              textContainer.appendChild(text);

              li.appendChild(boxSpan);
              li.appendChild(textContainer);
              ul.appendChild(li);
            });
          }
        },
      }

      if(!plugins.hasOwnProperty(name)){
        console.warn('The chart js plugin named ' + name + ' does not exists');
        return false;
      }

      return plugins[name];
    },
    getContrast: function(hexcolor){

      // If a leading # is provided, remove it
      if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
      }
    
      // If a three-character hexcode, make six-character
      if (hexcolor.length === 3) {
        hexcolor = hexcolor.split('').map(function (hex) {
          return hex + hex;
        }).join('');
      }
    
      // Convert to RGB value
      let r = parseInt(hexcolor.substr(0,2),16);
      let g = parseInt(hexcolor.substr(2,2),16);
      let b = parseInt(hexcolor.substr(4,2),16);
    
      // Get YIQ ratio
      let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    
      // Check contrast
      return (yiq >= 128) ? '#000000' : '#ffffff';
    
    },
    //truncate a string to a certain length and add ... if it exceeds
    truncateString: function(string, length){
      if(string && string.length > length){
        return string.substring(0, length) + '...';
      }
      return string;
    },
    convertCurrencyToInt:function(float){
      //multiply the float by 100
      var currency = float * 100;
      //round the currency
      return Math.round(currency);
    }
  }
}